import { useQuery } from "@tanstack/react-query";
import { externalGet } from "@shared/api/clients";

export interface CnpjApiResponse {
  razao_social: string;
  nome_fantasia: string;
  ddd_telefone_1: string;
  cnpj: string;
  descricao_situacao_cadastral: string;
}

const cleanCnpj = (cnpj: string): string => cnpj.replace(/[.\-/]/g, "");

const fetchCnpj = async (cnpj: string): Promise<CnpjApiResponse> => {
  return externalGet<CnpjApiResponse>(
    `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`,
  );
};

export const useCnpjQuery = (cnpj: string) => {
  const cleaned = cleanCnpj(cnpj);

  return useQuery<CnpjApiResponse>({
    queryKey: ["cnpj", cleaned],
    queryFn: () => fetchCnpj(cleaned),
    enabled: cleaned.length === 14,
    retry: false,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
  });
};
